import { Avatar, Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Pagination, Popover, Select, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material"
import { TABLE_HEADER_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors"
import useTagPromotionController from "./controller/tagPromotion"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import { TagPromotionModel } from "../../models/tagPromotion.model";
import { numberFormat } from "../../utils/nunberFormat";
import { convertDateStringToNormalDateTime } from "../../utils/convertDateFormat";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { PromotionEnumType } from "../../enums/promotionEnum";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../components/ConfirmDialog";
import { IMAGE_PRO_URL } from "../../lib/endpoints/promotion";
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { colorHexCodes, ColorName, ColorTagPromotionEnum } from "../../enums/colorTagPromotion";


interface Props {
  onCloseForm: VoidFunction
  data: TagPromotionModel[]
  onFetchTagPromotionData: VoidFunction
}

const TagPromotionComponent = ({ onCloseForm, data, onFetchTagPromotionData }: Props) => {
  const controller = useTagPromotionController({ data, onFetchTagPromotionData })
  const { t } = useTranslation('global')
  const TableHeadValue: string[] = [
    "No",
    "icon",
    "Name",
    " Promotion Type",
    // "Create Date",
    "Color",
    ""]

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton onClick={onCloseForm}>
          <ArrowBackIcon />
        </IconButton>
        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold" fontSize={35}>Tag Promotion</Typography>
      </Box>
      <Box sx={{
        p: 4,
        boxShadow:
          '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
        borderRadius: '10px',
        width: 800,
        height: '100%',
      }}>
        <Box>
          <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
            <Typography mb={2} fontWeight='bold' color={TEXT_TITLE_COLOR}>{controller.selectedData ? "Update" : "Create"} Tag Category</Typography>
            <Grid container spacing={2}>
              <Grid item xs={7} sm={7} md={7} p={3}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="promotion-label-id" shrink={true}>Promotion Type</InputLabel>
                  <Select
                    labelId="promotion-label-id"
                    id="promotion-id"
                    label="promotion Type"
                    value={controller.promotionType}
                    onChange={controller.handleSelectPromotionType}
                    inputProps={{
                      disableUnderline: true,
                    }}
                  >
                    {
                      Object.values(PromotionEnumType).map((type: PromotionEnumType) => (
                        <MenuItem key={type} value={type}>
                          {t("promotion_page." + type)}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
                <TextField fullWidth margin="normal" inputRef={controller.TagPromotionNameRef} label="Promotion Tag Name" InputLabelProps={{ shrink: true }} sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }} />
                <Typography mb={1} fontWeight='bold' color={TEXT_TITLE_COLOR}>Select Color</Typography>
                <Tabs
                  value={controller.selectedColor}
                  onChange={(event, newValue) => controller.handleSelectedColor(newValue)}
                  centered
                  TabIndicatorProps={{
                    style: {
                      display: 'none',
                    },
                  }}
                  sx={{
                    '& .MuiTabs-flexContainer': {
                      display: 'flex',
                      width: '100%',
                      gap: '12px',
                      '& .MuiTab-root': {
                        flex: 1,
                        minWidth: 0,
                        opacity: 0.4,
                        transition: 'opacity 0.3s',
                        '&.Mui-selected': {
                          opacity: 1,
                          fontWeight: 'bold'
                        }
                      }
                    }
                  }}
                >
                  {Object.keys(colorHexCodes).map((color) => (
                    <Tab
                      key={color}
                      value={color}
                      label={color}
                      style={{
                        background: `linear-gradient(to bottom, ${colorHexCodes[color as ColorName].top}, ${colorHexCodes[color as ColorName].bottom})`,
                        color: '#fff',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        opacity: controller.selectedColor === color ? 1 : 0.3,
                        fontWeight: controller.selectedColor === color ? 'bold' : 'normal',
                        transition: 'opacity 0.3s',
                      }}
                    />
                  ))}
                </Tabs>
              </Grid>
              {/* <Grid item xs={1} sm={1} md={1}>
                <div style={{ marginTop: '20px', marginRight: '20px' }}>
                  <div
                    style={{
                      background: `linear-gradient(to bottom, ${colorHexCodes[controller.selectedColor].top}, ${colorHexCodes[controller.selectedColor].bottom})`,
                      color: '#fff',
                      height: '100px', // adjust height as needed
                      width: '100%', // adjust width as needed
                      borderRadius: '8px', // optional for rounded corners
                    }}
                  />
                </div>
              </Grid> */}
              <Grid item xs={5} sm={5} md={5} p={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box mt={1} sx={{ width: 150, height: 150 }}>
                  <label htmlFor="image-input-tag">
                    <Avatar
                      src={controller.imageToShow ?? undefined}
                      variant="rounded"
                      alt=""
                      style={{
                        cursor: 'pointer',
                        width: 150,
                        height: 150,
                        objectFit: 'contain',
                        background: "#EBEBEB",
                        display: 'flex',
                        justifyContent: "center ",
                        alignItems: 'center',
                        flexDirection: "column",
                        borderRadius: "15px"
                      }}
                    >
                      <AddIcon sx={{ fontSize: 80, color: "#c9c9c9" }} />
                      <Typography color="#c9c9c9">Add Icon Tag</Typography>
                    </Avatar>
                  </label>
                  <input
                    type="file"
                    id="image-input-tag"
                    onClick={(e: any) => {
                      e.target.value = '';
                    }}
                    onChange={controller.handleSelectedImage}
                    style={{ display: 'none' }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Divider />
            <Box mt={2} mr={3} sx={{ display: 'flex', justifyContent: 'end', gap: 1 }}>
              {
                controller.selectedData && <Button variant="outlined" onClick={() => controller.handleCancelEditTagPro()} color="error" sx={{ textTransform: 'none', width: 150 }}>
                  Cancel
                </Button>
              }

              <Button type="submit" variant="contained" color="secondary" sx={{ textTransform: 'none', color: "#fff", width: 150 }}>
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
      {
        controller.loading ?
          <Box sx={{ width: 900, }}>
            <LinearProgress />
          </Box>
          : <Box
            sx={{
              p: 4,
              boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              borderRadius: '10px',
              width: 900,
              height: '100%',
              mt: 2
            }}
          >
            <TableContainer sx={{ mb: 1 }}>
              <Table>
                <TableHead sx={{ background: TABLE_HEADER_BACKGROUND_COLOR }}>
                  <TableRow >
                    {
                      TableHeadValue?.map((item: string, index: number) => (
                        <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>
                      ))
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    controller.rows?.map((row: TagPromotionModel, index: number) => (
                      <TableRow key={index}>
                        <TableCell sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (10 * (controller.currentPage - 1)))}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}><Avatar src={IMAGE_PRO_URL + row.image.url} /></TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{row?.tagName}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>{t("promotion_page." + row?.tagType)}</TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>
                          <>
                            <div
                              style={{
                                background: `linear-gradient(to bottom, ${colorHexCodes[row?.color as ColorName].top}, ${colorHexCodes[row?.color as ColorName].bottom})`,
                                color: '#fff',
                                height: '40px',
                                width: '40px',
                                borderRadius: '8px',
                              }}
                            />
                          </></TableCell>
                        <TableCell sx={{ borderBottom: 'none' }}>
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={(e: any) => controller.handleOpenPopover(e, row?.id)}
                          >
                            <MoreVertOutlinedIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                  <TableRow>

                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box mt={2} mb={2}>
              <Divider />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <Pagination
                color="primary"
                count={controller.countPagination}
                page={controller.currentPage}
                onChange={controller.handleChangePage}
              />
            </Box>
            <Popover
              open={Boolean(controller.openPopover)}
              anchorEl={controller.openPopover}
              onClose={controller.handleClosePopover}
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{
                sx: {
                  p: 1,
                  width: 200,
                  '& .MuiMenuItem-root': {
                    px: 1,
                    typography: 'body2',
                    borderRadius: 0.75,
                  },
                },
              }}
            >
              <MenuItem onClick={() => controller.handleClickEditButton()}>
                <EditIcon />
                &nbsp;&nbsp; Edit
              </MenuItem>
              <MenuItem sx={{ color: "error.main" }} onClick={() => controller.handleOpenDeleteForm()}>
                {" "}
                <DeleteIcon /> &nbsp;&nbsp; Delete
              </MenuItem>
            </Popover>
          </Box>
      }
      <ConfirmDialog
        open={controller.openConfirm}
        title="Do you want to Add this Data?"
        loading={controller.loadingButton}
        onCancel={controller.handleCloseForm}
        onConfirm={() => controller.handleSubmitForm()}
      />
      <ConfirmDialog
        open={controller.openDeleteForm}
        title="Do you want to Delete this Data?"
        loading={controller.loadingButton}
        onCancel={controller.handleCloseDeleteForm}
        onConfirm={() => controller.handleDeleteTagPromotion()}
      />
    </Box>
  )
}

export default TagPromotionComponent